export const ENCYCLOPEDIA_ID = 'encyclopediaFrame';
export const ENCYCLOPEDIA_ORIGIN = process.env.VUE_APP_ENCYCLOPEDIA_ORIGIN!;
